var header_height = $('.header-outer').height();
if($('.blackbar').length>0){
  $('.blackbar').css('top',header_height);
}
function scrollHeader(){
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('header').outerHeight();
  $(window).scroll(function(event){
    didScroll = true;
  });
  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);
  function hasScrolled() {
    var st = $(this).scrollTop();
    if(Math.abs(lastScrollTop - st) <= delta)
      return;    
    if (st > lastScrollTop && st > navbarHeight){
      $('body').addClass('sticky-down').removeClass('sticky-up');
      $('.blackbar').css('top',0);
      setTimeout(function () {
        $('.section-header,.section-header-unite').addClass('default-header');
        var header_height = $('.header-outer').height();
        $('#predictive-search').css({"top": header_height, "height": "calc(100% - "+header_height+"px)"});        
      }, 200);      
    } else {
      if(st + $(window).height() < $(document).height()) {
        $('body').removeClass('sticky-down').addClass('sticky-up');
        $('.blackbar').css('top',header_height);
        setTimeout(function () {
          $(window).scrollTop()<10?($(".section-header,.section-header-unite").removeClass("default-header")):($(".section-header,.section-header-unite").addClass("default-header"));
          var header_height = $('.header-outer').height();
          $('#predictive-search').css({"top": header_height, "height": "calc(100% - "+header_height+"px)"});         
        }, 200);        
      }
    }
    lastScrollTop = st;
  }
  $(window).scroll(function(event){
    $(this).scrollTop()==0?($("body").addClass("header-sticky")):($("body").removeClass("header-sticky"));    
  });
}
// if (window.innerWidth > 991) { 
scrollHeader();
// }
var windowtop = $(window).scrollTop();
if(windowtop>100){
  $('.section-header,.section-header-unite').addClass('default-header');
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search','open-account','unite-menuopen','zoom-active');
  }
};
$('body').css('padding-top',header_height);
$('.product-carousel').each(function(e){
  var thisslider = $(this);
  $(this).flickity({pageDots: false,cellAlign:"left",contain:true});         
});
if($(window).width()<992){
  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
  window.addEventListener('resize', appHeight)
  appHeight()
}
if($('.relcls').length > 0){
  $('.lvolumeon').on('click',function(e){
    $(this).closest('.musicbtn').find('.lvolumeoff').show();
    $(this).hide();
    var current_a_id = $(this).closest('.relcls').find('.jwplayer').attr('id');
    var player = jwplayer(current_a_id);
    player.setMute(true);
  });
  $('.lvolumeoff').on('click',function(e){
    $(this).closest('.musicbtn').find('.lvolumeon').show();
    $(this).hide();
    var current_a_id = $(this).closest('.relcls').find('.jwplayer').attr('id');
    var playervol = jwplayer(current_a_id); 
    playervol.setVolume(1);
    setTimeout(function (e) {
      $('.relcls').each(function (e) {
        if (!$(this).hasClass("active")) {
          var mediawrapother = $(this).find('.media-video').attr('id');
          var videoidother = $(this).find('.media-video').data('id');
          var playerother = jwplayer(mediawrapother);
         // playerother.setVolume(0);           
        }        
      });
    },1000);    
  });
  $('.lfullvideo_screen').on('click',function(e){
    var vcurrent_a_id = $(this).closest('.relcls').find('.jwplayer').attr('id');
    var vplayervol = jwplayer(vcurrent_a_id); 
    vplayervol.setFullscreen(true);
    setTimeout(function (e) {
      $('.relcls').each(function (e) {
        if (!$(this).hasClass("active")) {
          var vmediawrapother = $(this).find('.media-video').attr('id');
          var vvideoidother = $(this).find('.media-video').data('id');
          var vplayerother = jwplayer(vmediawrapother);
          //vplayerother.setFullscreen(false);
        }
      });
    },1000);
  });
}  
 $(".top_content").matchHeight({property:"height"});
$(document).on('click','.quickviewbtn',function(e){
  e.preventDefault();
  let productHandle = $(this).data('handle');
  let colltitle = $(this).data('title');
  let href = `/products/${productHandle}?view=quick-view`;
  fetch(href, {
    method: 'GET'
  })
  .then((response) => {
    //quickview_button.classList.remove('loading');
    return response.text();
  })
  .then(text => {
     const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#Product-Drawer-Content').innerHTML;
     $('.quickview-htmldata').html(sectionInnerHTML);
     $('body').addClass('quickview-open');     
     $(".qv-product-mediamobinr").flickity({
        contain:true,pageDots: false,wrapAround: true,imagesLoaded: true
     });
     $('.product-subtitle').text(colltitle);

      if (!window.location.href.includes('women')) {
      // Remove the images with alt text containing 'wmn'
      $('.qv-media-grid-column img[alt*="wmn"]').remove();
      }
      if (window.location.href.includes('women')) {
      // Remove the images with alt text containing 'men'
      $('.qv-media-grid-column img[alt*="men"]').remove();
      }
      // Check if there are no images with alt text containing 'modelshot'
      if ($('.qv-media-grid-column img[alt*="Modelshot"]').length === 0) {
        // Hide the .qv-model_field
        $('.qv-model_field').attr('style', 'display: none !important');
      }
  });
});
$(document).on('click','.close_quickview,.overlay-box',function(e){
  e.preventDefault();
  $('.quickview-htmldata').html('');
  $('body').removeClass('quickview-open');
});
$(document).on('click','.qv-varaintlist',function (e) {
  e.preventDefault();
  $(this).addClass('active').parent().siblings().find('.qv-varaintlist').removeClass('active'); 
  $('.qv-static-cart').hide();
  $('.qv-dynamic-cart').show();  
  $('.qv-dynamic-cart').attr('data-id',$(this).data('id'));
});
$(document).on('click','.qv-dynamic-cart',function (e) {
  e.preventDefault();
  let varid = $(this).data('id');
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: varid, quantity: 1 },
    dataType: "json",
    beforeSend: function () {
      
    },
    success: function (data) {          
       if(window.location.href.includes('cart'))
      {
        window.location.href = "/cart";
      }else{
        load_cart();
        $('body').addClass('open-drawer');
        $('.quickview-htmldata').html('');
        $('body').removeClass('quickview-open');
      }
    },
    error: function (e, t) {
      $('.qv-cartpage_error').text(e.responseJSON.description);
      setTimeout(function(){
         $('.qv-cartpage_error').text('e.responseJSON.description');                  
      }, 3000);
    },
  });
});
$(document).on('click','.size_grid li',function(){
let varid = $(this).attr('data-id');
    $(this).parent('.size_grid').siblings('.quickviewbtn-wrapper').find('.quickviewbtn').trigger('click');
  setTimeout(function() {
    $('.qv-varaintlist[data-id="'+varid+'"]').trigger('click');
  },1400)
})

const sectionLongImage = document.querySelector(".section-long-image");

if(__st.p == 'home' && sectionLongImage){
  // gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
  // ScrollSmoother.create({
  //   wrapper: "#smooth-wrapper",
  //   content: "#MainContent",
  //   smooth: 1.5,
  //   // normalizeScroll: true,
  //   effects: true
  // });
  if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)){
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    ScrollSmoother.create({
      wrapper: "#smooth-wrapper",
      content: "#MainContent",
      smooth: 1.5,
      effects: true
    });
    gsap.set(".li-meta-inr", { height: "100vh" });
    gsap.to(".li-meta-inr", {
      scrollTrigger: {
        trigger: ".li-meta-inr",
        start: "top top",
        end: () => sectionLongImage.offsetHeight - window.innerHeight + 350 + "px",
        pin: true,
        scrub: 1,
        anticipatePin: 1,
      }
    });
  }else{
    gsap.set(".li-meta-inr", { height: "100vh" });
    gsap.to(".li-meta-inr", {
      scrollTrigger: {
        trigger: ".li-meta-inr",
        start: "top top",
        end: () => sectionLongImage.offsetHeight - window.innerHeight + 350 + "px",
        pin: true,
        scrub: 1,
        anticipatePin: 1,
        onEnter: () => {
          document.querySelector('.li-meta-inr').classList.add('meta-sticky');
        },
        onLeave: () => {
          document.querySelector('.li-meta-inr').classList.remove('meta-sticky');
        },
        onEnterBack: () => {
          document.querySelector('.li-meta-inr').classList.add('meta-sticky');
        },
        onLeaveBack: () => {
          document.querySelector('.li-meta-inr').classList.remove('meta-sticky');
        }
      }
    });
  }
}

document.querySelectorAll('.pass-wrap .show-pass').forEach(toggle => {
  toggle.addEventListener('click', function () {
    const input = this.closest('.pass-wrap').querySelector('input');
    if (input.type === 'password') {
      input.type = 'text';
    } else {
      input.type = 'password';
    }
  });
});
const animationObserverOptions = {
  rootMargin: "-100px",
};
const animationObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      return;
    }
    entry.target.classList.add("animation-init");
    entry.target.addEventListener(
      "animationend",
      () => {
        entry.target.classList.add("animation-none");
      },
      {
        once: true,
      }
    );
    animationObserver.unobserve(entry.target);
  });
}, animationObserverOptions);
observeAnimationElements();
window.addEventListener("shopify:section:load", () => {
  observeAnimationElements();
});
function observeAnimationElements() {
  const animationElements = document.querySelectorAll(
    '[class*="js-animation-"]'
  );
  animationElements.forEach((animationElement) => {
    animationObserver.observe(animationElement);
  });
}
